<template>
	<el-form-item label="链接名称">
		<el-input v-model="data.options.defaultValue" />
	</el-form-item>

	<el-form-item label="href">
		<el-input v-model="data.options.href" />
	</el-form-item>

	<el-form-item label="类型">
		<el-select v-model="data.options.type" style="width: 100%">
			<el-option label="default" value="default" />
			<el-option label="primary" value="primary" />
			<el-option label="success" value="success" />
			<el-option label="info" value="info" />
			<el-option label="warning" value="warning" />
			<el-option label="danger" value="danger" />
		</el-select>
	</el-form-item>

	<el-form-item label="是否下划线">
		<el-switch v-model="data.options.underline" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemLink',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
